import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);
    const [token, setTokenState] = useState(() => localStorage.getItem("cmrenov_token") || null);

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            axios.get(`${API}/auth/me`).then((r) => setUser(r.data)).catch(() => {
                localStorage.removeItem("cmrenov_token");
                setTokenState(null);
                delete axios.defaults.headers.common["Authorization"];
            }).finally(() => setReady(true));
        } else {
            delete axios.defaults.headers.common["Authorization"];
            setReady(true);
        }
    }, [token]);

    const setToken = (t) => {
        if (t) {
            localStorage.setItem("cmrenov_token", t);
            axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
        } else {
            localStorage.removeItem("cmrenov_token");
            delete axios.defaults.headers.common["Authorization"];
        }
        setTokenState(t);
    };

    const logout = () => { setToken(null); setUser(null); };

    return (
        <AuthCtx.Provider value={{ user, token, ready, setToken, setUser, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
